"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIndicator = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const LoadingIndicator_styles_1 = require("./LoadingIndicator.styles");
const LoadingIndicator = ({ animationDuration = 1000, useNativeDriver = false, fullScreen = false, ...otherProps }) => {
    const [spinValue] = react_1.useState(new react_native_1.Animated.Value(0));
    react_1.useEffect(() => {
        const animation = react_native_1.Animated.loop(react_native_1.Animated.timing(spinValue, {
            toValue: 1,
            duration: animationDuration,
            easing: react_native_1.Easing.linear,
            useNativeDriver,
        }));
        animation.start();
        return () => {
            animation.stop();
        };
    }, [animationDuration]);
    const animatedStyle = {
        transform: [
            {
                rotate: spinValue.interpolate({
                    inputRange: [0, 1],
                    outputRange: ['0deg', '360deg'],
                }),
            },
        ],
    };
    if (fullScreen) {
        return (react_1.default.createElement(LoadingIndicator_styles_1.FullScreenCanvasView, null,
            react_1.default.createElement(LoadingIndicator_styles_1.LoadingView, Object.assign({}, otherProps, { style: animatedStyle, testID: "LoadingIndicator" }))));
    }
    return (react_1.default.createElement(LoadingIndicator_styles_1.LoadingView, Object.assign({}, otherProps, { style: animatedStyle, testID: "LoadingIndicator" })));
};
exports.LoadingIndicator = LoadingIndicator;
